module.exports = __webpack_public_path__ + "static/media/aab-logo-white.fa33a939.png";